export const dataHooks = {
    input: 'list-item-editable-input',
    approveButton: 'list-item-editable-approve-button',
    cancelButton: 'list-item-editable-cancel-button',
    approveButtonTooltip: 'list-item-editable-approve-button-tooltip',
    cancelButtonTooltip: 'list-item-editable-cancel-button-tooltip',
};
export var ListItemEditableSize;
(function (ListItemEditableSize) {
    ListItemEditableSize["SMALL"] = "small";
    ListItemEditableSize["MEDIUM"] = "medium";
})(ListItemEditableSize || (ListItemEditableSize = {}));
export var ListItemEditableMargins;
(function (ListItemEditableMargins) {
    ListItemEditableMargins["LIST_ITEM"] = "list-item";
    ListItemEditableMargins["NONE"] = "none";
})(ListItemEditableMargins || (ListItemEditableMargins = {}));
//# sourceMappingURL=ListItemEditable.constants.js.map